export const CUSTOMIZE_QR_CODE_WIZARD_TEXT = {
  step: 'customize',
  navTitle: 'Customize',
  stepTitle: 'Customize QR Code',
  description: 'We recommend using these styling options to brand your QR code to fit your campaign needs.',
} as const;
